import {
  PrimeMode,
  PrimeQuotaResult,
  QuotaDetails,
  QuotaItem,
  QuotaType,
  UserPlatformPlan
} from './types';

export const PRIME_MODE_TO_QUOTA_TYPE: Record<PrimeMode, QuotaType> = {
  [PrimeMode.VIDEO]: QuotaType.PRIME_VIDEO_WATCHED,
  [PrimeMode.PRACTICE]: QuotaType.PRIME_PRACTICE,
  [PrimeMode.TEST]: QuotaType.PRIME_TEST,
  [PrimeMode.COMPETE]: QuotaType.PRIME_COMPETE
};

export const getQuotaItemByType = (
  quotaDetails: QuotaDetails | null,
  quotaType: QuotaType
): QuotaItem | undefined => {
  if (!quotaDetails) return undefined;

  const quotaItems = Object.values(quotaDetails).filter(Boolean) as QuotaItem[];

  return quotaItems.find((item) => item.quotaType === quotaType);
};

export const getPrimeQuotaForMode = ({
  mode,
  quotaDetails,
  userPlatformPlan
}: {
  mode: PrimeMode;
  quotaDetails: QuotaDetails | null;
  userPlatformPlan: UserPlatformPlan | null;
}): PrimeQuotaResult => {
  const quotaType = PRIME_MODE_TO_QUOTA_TYPE[mode];
  const quotaItem = getQuotaItemByType(quotaDetails, quotaType);
  const usage = quotaItem?.usages?.[0];

  const total = usage?.total ?? 0;
  const used = usage?.used ?? 0;
  const left = Math.max(total - used, 0);

  return {
    quotaType,
    freqType: usage?.freqType,
    total,
    used,
    left,
    isQuotaExhausted: userPlatformPlan === UserPlatformPlan.FREE && left <= 0,
    userPlatformPlan
  };
};
